import {Controller} from "stimulus"
import * as basicScroll from 'basicscroll'
import Browser from "../utils/Browser";

export default class extends Controller {

    static targets = ["triggerElement", "image"]

    initialize() {

        const browser = new Browser

        if ( browser.name === "Internet Explorer" ) {
            return false
        }

        this.initScene()

    }

    initScene() {

        const template = document.createElement("template")
        template.innerHTML = `<div class="parallax-image__overlay"></div>`

        this.$image.parentNode.insertBefore(template.content.querySelector("div"), this.$image.nextSibling)

        const instance = basicScroll.create({
            elem: this.$triggerElement,

            // First argument = from where the animation start
            // Second argument = linked to the element
            // from: "top-bottom",

            // Second argument = where the animation end
            // top: "bottom-top",

            from: "top-top", // doc, el
            to: "bottom-top",
            direct: true,
            props: {
                '--opacity-overlay': {
                    from: 0,
                    to: 0.7,
                    //timing: 'expoIn'
                },
                '--translateY': {
                    to: '20%',
                    from: '0%',
                    //timing: 'expoIn'
                },
                '--scale': {
                    from: 1,
                    to: 1.1,
                    //timing: 'expoIn'
                }
            }
        })

        instance.start()


    }

    get $image() {
        return this.imageTarget
    }

    get $triggerElement() {
        return this.triggerElementTarget
    }

}